import { ArrowRight } from 'lucide-react';
import { FOUNDING_MEMBER_PRICE, FOUNDING_MEMBER_SPOTS } from '../constants';

interface CTASectionProps {
  onOpenSignup: () => void;
  spotsTaken: number;
}

export default function CTASection({ onOpenSignup, spotsTaken }: CTASectionProps) {
  return (
    <section className="py-10 md:py-16 px-4 relative">
      {/* Gym background hint */}
      <div className="absolute inset-0 opacity-[0.06]" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1540497077202-7c8a3999166f?w=1920&q=80")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }} />
      <div className="absolute inset-0 bg-gradient-to-t from-[#161b26] via-[#161b26]/90 to-[#161b26]" />

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-xl md:text-4xl font-extrabold mb-3 md:mb-4">
          Stop waiting on hold.
          <br />
          <span className="text-blue-400">Start running your own gym.</span>
        </h2>
        <p className="text-white/50 text-sm mb-6 max-w-md mx-auto">
          {spotsTaken} of {FOUNDING_MEMBER_SPOTS} founding spots are taken. ${FOUNDING_MEMBER_PRICE}/month — locked for life.
        </p>
        <button
          onClick={onOpenSignup}
          className="group inline-flex items-center gap-2 px-6 py-3 md:px-8 md:py-4 bg-blue-500 hover:bg-blue-600 text-white font-bold text-sm md:text-base rounded-xl transition-all duration-200 shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40"
        >
          Become a Founding Member
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </button>
        <p className="mt-4 text-white/20 text-xs">
          No free trials. No gimmicks. Just a ridiculous deal for people who get in early.
        </p>
      </div>
    </section>
  );
}
